module.exports = __webpack_public_path__ + "img/servicing.098d3321.png";